import styled from "styled-components";

const Background = styled.div<{ color: string; }>` 
  background: ${props => props.color};
  min-height: 100vh;
`;

export default Background;
